module.exports = __webpack_public_path__ + "img/gallery-2.5fcf08c5.png";